module.exports = __webpack_public_path__ + "static/media/bottom-bg.2c7b8ca1.png";